const elements = {
  subscriptionForm: document.querySelector('[data-news-subscription-form]'),
  feedbackForm: document.querySelector('[data-feedback-form]'),
};

export default elements;
